<template>
    <b-navbar variant="dark" type="dark" class="py-1 rootNavbar" sticky>
        <b-navbar-brand href="#">
            <img width="42px" height="42px" src="../assets/navlogo.png" class="d-inline-block align-middle mr-2 ml-0 p-0" >
            VO2 Master Cloud
        </b-navbar-brand>
        <b-navbar-nav class="d-none d-md-block">
          <b-nav-item :to="{name:'OrganizationList'}">
            <font-awesome-icon icon="users" class="mx-3" />
            <b>{{organizationDisplayName}}</b>
            <font-awesome-icon icon="caret-down" class="mx-1 align-text-bottom" />
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right>
                <template v-slot:button-content>
                    <small><b>{{userDisplayName}}</b></small>
                    <font-awesome-icon icon="user" class="mx-2" />
                </template>

                <b-dropdown-item :to="{name:'UserDetails'}">Profile</b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item v-on:click.stop="logout()">Logout</b-dropdown-item>

            </b-nav-item-dropdown>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "HeaderNav",
        computed: {
            ...mapGetters({
                organization: 'organization/current',
                organizationName: 'organization/currentName',
                userAccountName: 'userAccount/currentName',
            }),

            organizationDisplayName: function() {
                if(this.organization) {
                    return this.organizationName.truncate(26);
                }
                return "Please Select Organization..."
            },
            userDisplayName: function() {
                return this.userAccountName.truncate(26);
            }
        },
        methods: {
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            }
        }
    }

</script>

<style scoped>


  .navbar-dark .navbar-nav .nav-link {
    color: rgb(220,220,220);
  }

</style>